// extracted by mini-css-extract-plugin
export default {"registerContainer":"VerifyPage_registerContainer__A6vUh"};